import { render } from "./SidebarLink.vue?vue&type=template&id=64810c23"
import script from "./SidebarLink.vue?vue&type=script&lang=js"
export * from "./SidebarLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__